import { render, staticRenderFns } from "./OutdatedBrowser.vue?vue&type=template&id=1d74191b&scoped=true&"
var script = {}
import style0 from "./OutdatedBrowser.vue?vue&type=style&index=0&id=1d74191b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loa_04cfefe4e5633ef36867eab2fc0c6666/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d74191b",
  null
  
)

export default component.exports